$('#update-user').on('click', () => confirm("Are you sure?"));